import { Step } from "react-joyride";

export const tourStepsResources = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.mb-8",
      content:
        "Resources has answers to common questions, plus planned video walkthroughs when they are ready.",
      disableBeacon: true,
    },
    {
      target: ".faq-section",
      content:
        "Read the FAQs first if you are stuck. They cover collections, sessions, and account questions.",
    },
    {
      target: ".videos-section",
      content:
        "Instructional videos for the main parts of the site are coming soon — collections, practice, games, reports, and more. Until then, use the FAQs and guided tours.",
    },
  ];

  return steps;
};
